"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'nav.model.fallback': 'Model AI',
};
